var _path, _path2, _path3, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenez(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 30,
    viewBox: "0 0 60 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H60V10H0V0Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10H60V20H0V10Z",
    fill: "#00247D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H60V30H0V20Z",
    fill: "#CF142B"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "23.50,18.50 23.85,19.51 24.93,19.54 24.07,20.19 24.38,21.21 23.50,20.60 22.62,21.21 22.93,20.19 22.07,19.54 23.15,19.51",
    fill: "white"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.14,15.68 24.50,16.69 25.57,16.72 24.71,17.37 25.03,18.39 24.14,17.78 23.26,18.39 23.57,17.37 22.72,16.72 23.79,16.69",
    fill: "white"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "25.95,13.42 26.30,14.43 27.37,14.45 26.52,15.10 26.83,16.13 25.95,15.52 25.07,16.13 25.38,15.10 24.52,14.45 25.59,14.43",
    fill: "white"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "28.55,12.16 28.91,13.18 29.98,13.20 29.12,13.85 29.44,14.88 28.55,14.26 27.67,14.88 27.98,13.85 27.13,13.20 28.20,13.18",
    fill: "white"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.45,12.16 31.80,13.18 32.87,13.20 32.02,13.85 32.33,14.88 31.45,14.26 30.56,14.88 30.88,13.85 30.02,13.20 31.09,13.18",
    fill: "white"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.05,13.42 34.41,14.43 35.48,14.45 34.62,15.10 34.93,16.13 34.05,15.52 33.17,16.13 33.48,15.10 32.63,14.45 33.70,14.43",
    fill: "white"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "35.86,15.68 36.21,16.69 37.28,16.72 36.43,17.37 36.74,18.39 35.86,17.78 34.97,18.39 35.29,17.37 34.43,16.72 35.50,16.69",
    fill: "white"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "36.50,18.50 36.85,19.51 37.93,19.54 37.07,20.19 37.38,21.21 36.50,20.60 35.62,21.21 35.93,20.19 35.07,19.54 36.15,19.51",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenez);
export default __webpack_public_path__ + "static/media/venez.b138e6d1f8a0fe8dc263c236b6724419.svg";
export { ForwardRef as ReactComponent };